var _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 2,
    height: 4,
    rx: 0.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 2,
    height: 6,
    rx: 0.5,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 2,
    width: 2,
    height: 8,
    rx: 0.5,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    width: 2,
    height: 10,
    rx: 0.5,
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignal);
export default __webpack_public_path__ + "static/media/signal.dc838a3e024faa13203e479b184cf342.svg";
export { ForwardRef as ReactComponent };